/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LocationArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Location Arrow 24">
      <path
        fill="#0E0E0E"
        d="M16.344 5.024 5.285 9.833c-1.906.828-1.44 3.654.632 3.827L10 14l.34 4.084c.173 2.07 2.999 2.537 3.828.63l4.808-11.058c.724-1.665-.967-3.356-2.632-2.632Z"
        className="SVG"
      />
    </g>
  </svg>
);

export const LocationArrowIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'location-arrow-icon'}
      icon={LocationArrow}
      {...props}
      size={size}
    />
  );
};
